var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 500",
    preserveAspectRatio: "xMaxYMax slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.7451564828614009)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1342,
    height: 671,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.94,0 41.94,41.94 0,41.94",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.94,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.94,0 83.88,41.94 41.94,41.94",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,41.94 41.94,41.94 0,83.88",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.94,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.94,41.94 83.88,41.94 83.88,83.88",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.875,
    y: 0,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.88,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.88 0 A 41.94 41.94 0 0 0 125.82 41.94 L 125.82 0",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.81,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125.81 41.94 A 41.94 41.94 0 0 0 167.75 0 L 125.81 0",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.88,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.88 83.88 A 41.94 41.94 0 0 1  125.82 41.94 L 125.82 83.88",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.81,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125.81 41.94 A 41.94 41.94 0 0 1 167.75 83.88 L 125.81 83.88",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.75,
    y: 0,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.75,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167.75 0 A 41.94 41.94 0 0 0 209.69 41.94 L 209.69 0",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.69,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 209.69 41.94 A 41.94 41.94 0 0 0 251.63 0 L 209.69 0",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.75,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167.75 83.88 A 41.94 41.94 0 0 1  209.69 41.94 L 209.69 83.88",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.69,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 209.69 41.94 A 41.94 41.94 0 0 1 251.63 83.88 L 209.69 83.88",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.63,
    y: 0,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.63,
    y: 0,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.5,
    y: 0,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 335.5 0 A 83.88 83.88 0 0 1  419.38 83.88 L 335.5 0 A 83.88 83.88 0 0 0 419.38 83.88",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.38,
    y: 0,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.38,
    y: 0,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.25,
    y: 0,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 503.25 0 A 83.88 83.88 0 0 0 587.13 83.88 L 587.13 0",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.125,
    y: 0,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.13,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 587.13 41.94 A 41.94 41.94 0 0 1 629.0699999999999 0 L 629.0699999999999 10.485 A 31.455 31.455 0 0 0 597.615 41.94",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.06,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 629.06 0 A 41.94 41.94 0 0 1 671 41.94 L 660.515 41.94 A 31.455 31.455 0 0 0 629.06 10.485",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.13,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 587.13 41.94 A 41.94 41.94 0 0 0 629.0699999999999 83.88 L 629.0699999999999 73.395 A 31.455 31.455 0 0 1 597.615 41.94",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.06,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 629.06 83.88 A 41.94 41.94 0 0 0 671 41.94 L 660.515 41.94 A 31.455 31.455 0 0 1 629.06 73.395",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 0,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 671 0 A 41.94 41.94 0 0 1 712.94 41.94 L 671 41.94",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712.94,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 712.94 41.94 A 41.94 41.94 0 0 1  754.8800000000001 0 L 754.8800000000001 41.94",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 671 83.88 A 41.94 41.94 0 0 0 712.94 41.94 L 671 41.94",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712.94,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 712.94 41.94 A 41.94 41.94 0 0 0 754.8800000000001 83.88 L 754.8800000000001 41.94",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.875,
    y: 0,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.88,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "796.8199999999999,0 796.8199999999999,41.94 754.88,41.94",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.81,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "796.81,0 838.75,41.94 796.81,41.94",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.88,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "754.88,41.94 796.8199999999999,41.94 796.8199999999999,83.88",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.81,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "796.81,41.94 838.75,41.94 796.81,83.88",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 0,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "880.69,0 880.69,41.94 838.75,41.94",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.69,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "880.69,0 922.6300000000001,41.94 880.69,41.94",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "838.75,41.94 880.69,41.94 838.75,83.88",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.69,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "880.69,41.94 922.6300000000001,41.94 922.6300000000001,83.88",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.63,
    y: 0,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 922.63 83.88 A 83.88 83.88 0 0 1  1006.51 0 L 1006.51 83.88",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 0,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 0,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.375,
    y: 0,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.38,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1090.38 41.94 A 41.94 41.94 0 0 1 1132.3200000000002 0 L 1132.3200000000002 10.485 A 31.455 31.455 0 0 0 1100.865 41.94",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1132.31,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1132.31 0 A 41.94 41.94 0 0 1 1174.25 41.94 L 1163.7649999999999 41.94 A 31.455 31.455 0 0 0 1132.31 10.485",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.38,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1090.38 41.94 A 41.94 41.94 0 0 0 1132.3200000000002 83.88 L 1132.3200000000002 73.395 A 31.455 31.455 0 0 1 1100.865 41.94",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1132.31,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1132.31 83.88 A 41.94 41.94 0 0 0 1174.25 41.94 L 1163.7649999999999 41.94 A 31.455 31.455 0 0 1 1132.31 73.395",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 0,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1216.19,0 1216.19,41.94 1174.25,41.94",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216.19,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1216.19,0 1258.13,41.94 1216.19,41.94",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.25,41.94 1216.19,41.94 1216.19,83.88",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216.19,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1216.19,41.94 1258.13,41.94 1216.19,83.88",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.125,
    y: 0,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.13,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1300.0700000000002,0 1300.0700000000002,41.94 1258.13,41.94",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300.06,
    y: 0,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1300.06,0 1342,41.94 1300.06,41.94",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.13,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1258.13,41.94 1300.0700000000002,41.94 1300.0700000000002,83.88",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300.06,
    y: 41.94,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1300.06,41.94 1342,41.94 1300.06,83.88",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 83.88,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 83.88 A 83.88 83.88 0 0 1  83.88 167.76 L 0 83.88 A 83.88 83.88 0 0 0 83.88 167.76",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.88,
    y: 83.88,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.88,
    y: 83.88,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.75,
    y: 83.88,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.75,
    y: 83.88,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.625,
    y: 83.875,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.63,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 251.63 125.82 A 41.94 41.94 0 0 0 293.57 83.88 L 251.63 83.88",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.56,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 293.56 83.88 A 41.94 41.94 0 0 0 335.5 125.82 L 335.5 83.88",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.63,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 251.63 125.81 A 41.94 41.94 0 0 1 293.57 167.75 L 251.63 167.75",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.56,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 293.56 167.75 A 41.94 41.94 0 0 1  335.5 125.81 L 335.5 167.75",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.5,
    y: 83.88,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 335.5 167.76 A 83.88 83.88 0 0 1  419.38 83.88 L 419.38 167.76",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.38,
    y: 83.88,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "503.26,83.88 503.26,167.76 419.38,167.76",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.25,
    y: 83.88,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "503.25,83.88 587.13,83.88 503.25,167.76",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.125,
    y: 83.875,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.13,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 587.13 83.88 A 41.94 41.94 0 0 0 629.0699999999999 125.82 L 629.0699999999999 83.88",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.06,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 629.06 125.82 A 41.94 41.94 0 0 0 671 83.88 L 629.06 83.88",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.13,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 587.13 167.75 A 41.94 41.94 0 0 1  629.0699999999999 125.81 L 629.0699999999999 167.75",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.06,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 629.06 125.81 A 41.94 41.94 0 0 1 671 167.75 L 629.06 167.75",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 83.875,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 671 125.82 A 41.94 41.94 0 0 1  712.94 83.88 L 712.94 125.82",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712.94,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 712.94 83.88 A 41.94 41.94 0 0 1 754.8800000000001 125.82 L 712.94 125.82",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 671 125.81 A 41.94 41.94 0 0 0 712.94 167.75 L 712.94 125.81",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712.94,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 712.94 167.75 A 41.94 41.94 0 0 0 754.8800000000001 125.81 L 712.94 125.81",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.875,
    y: 83.875,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.88,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 754.88 83.88 A 41.94 41.94 0 0 0 796.8199999999999 125.82 L 796.8199999999999 83.88",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.81,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 796.81 125.82 A 41.94 41.94 0 0 0 838.75 83.88 L 796.81 83.88",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.88,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 754.88 167.75 A 41.94 41.94 0 0 1  796.8199999999999 125.81 L 796.8199999999999 167.75",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.81,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 796.81 125.81 A 41.94 41.94 0 0 1 838.75 167.75 L 796.81 167.75",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 83.875,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "880.69,83.88 880.69,125.82 838.75,125.82",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.69,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "880.69,83.88 922.6300000000001,83.88 880.69,125.82",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "838.75,125.81 880.69,125.81 880.69,167.75",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.69,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "880.69,125.81 922.6300000000001,167.75 880.69,167.75",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.625,
    y: 83.875,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.63,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 943.6,
    cy: 104.85,
    r: 20.97,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.56,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.56,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.63,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 943.6,
    cy: 146.78,
    r: 20.97,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.56,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.56,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 83.88,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1006.5 167.76 A 83.88 83.88 0 0 1  1090.38 83.88 L 1006.5 167.76 A 83.88 83.88 0 0 0 1090.38 83.88",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.375,
    y: 83.875,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.38,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1132.3200000000002,83.88 1132.3200000000002,125.82 1090.38,125.82",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1132.31,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1132.31,83.88 1174.25,125.82 1132.31,125.82",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.38,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1090.38,125.81 1132.3200000000002,125.81 1132.3200000000002,167.75",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1132.31,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1132.31,125.81 1174.25,125.81 1132.31,167.75",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 83.88,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 83.88,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.125,
    y: 83.875,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.13,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1258.13 83.88 A 41.94 41.94 0 0 0 1300.0700000000002 125.82 L 1300.0700000000002 83.88",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300.06,
    y: 83.88,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1300.06 125.82 A 41.94 41.94 0 0 0 1342 83.88 L 1300.06 83.88",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.13,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1258.13 167.75 A 41.94 41.94 0 0 1  1300.0700000000002 125.81 L 1300.0700000000002 167.75",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300.06,
    y: 125.81,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1300.06 125.81 A 41.94 41.94 0 0 1 1342 167.75 L 1300.06 167.75",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 167.75,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 167.75,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.88,
    y: 167.75,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.76,167.75 167.76,251.63 83.88,251.63",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.75,
    y: 167.75,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167.75 167.75 A 83.88 83.88 0 0 0 251.63 251.63 L 251.63 167.75",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.625,
    y: 167.75,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.63,
    y: 167.75,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 251.63 167.75 A 41.94 41.94 0 0 1 293.57 209.69 L 251.63 209.69",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.56,
    y: 167.75,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 293.56 209.69 A 41.94 41.94 0 0 1  335.5 167.75 L 335.5 209.69",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.63,
    y: 209.69,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 251.63 251.63 A 41.94 41.94 0 0 0 293.57 209.69 L 251.63 209.69",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.56,
    y: 209.69,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 293.56 209.69 A 41.94 41.94 0 0 0 335.5 251.63 L 335.5 209.69",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.5,
    y: 167.75,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.5,167.75 419.38,251.63 335.5,251.63",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.375,
    y: 167.75,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.38,
    y: 167.75,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 419.38 209.69 A 41.94 41.94 0 0 1  461.32 167.75 L 461.32 209.69",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.31,
    y: 167.75,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 461.31 167.75 A 41.94 41.94 0 0 1 503.25 209.69 L 461.31 209.69",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.38,
    y: 209.69,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 419.38 209.69 A 41.94 41.94 0 0 0 461.32 251.63 L 461.32 209.69",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.31,
    y: 209.69,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 461.31 251.63 A 41.94 41.94 0 0 0 503.25 209.69 L 461.31 209.69",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.25,
    y: 167.75,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 503.25 167.75 A 83.88 83.88 0 0 0 587.13 251.63 L 587.13 167.75",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.13,
    y: 167.75,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "587.13,167.75 671.01,167.75 671.01,251.63",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 167.75,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 671 251.63 A 83.88 83.88 0 0 1  754.88 167.75 L 671 251.63 A 83.88 83.88 0 0 0 754.88 167.75",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.875,
    y: 167.75,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.88,
    y: 167.75,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 754.88 209.69 A 41.94 41.94 0 0 1 796.8199999999999 167.75 L 796.8199999999999 178.235 A 31.455 31.455 0 0 0 765.365 209.69",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.81,
    y: 167.75,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 796.81 167.75 A 41.94 41.94 0 0 1 838.75 209.69 L 828.265 209.69 A 31.455 31.455 0 0 0 796.81 178.235",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.88,
    y: 209.69,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 754.88 209.69 A 41.94 41.94 0 0 0 796.8199999999999 251.63 L 796.8199999999999 241.14499999999998 A 31.455 31.455 0 0 1 765.365 209.69",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.81,
    y: 209.69,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 796.81 251.63 A 41.94 41.94 0 0 0 838.75 209.69 L 828.265 209.69 A 31.455 31.455 0 0 1 796.81 241.14499999999998",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 167.75,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 838.75 251.63 A 83.88 83.88 0 0 1  922.63 167.75 L 922.63 251.63",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.625,
    y: 167.75,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.63,
    y: 167.75,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "964.5699999999999,167.75 964.5699999999999,209.69 922.63,209.69",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.56,
    y: 167.75,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "964.56,167.75 1006.5,209.69 964.56,209.69",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.63,
    y: 209.69,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "922.63,209.69 964.5699999999999,209.69 922.63,251.63",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.56,
    y: 209.69,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "964.56,209.69 1006.5,209.69 1006.5,251.63",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 167.75,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1006.5,167.75 1090.38,167.75 1090.38,251.63",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.38,
    y: 167.75,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1090.38,167.75 1174.2600000000002,251.63 1090.38,251.63",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 167.75,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 167.75,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1216.19,167.75 1216.19,209.69 1174.25,209.69",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216.19,
    y: 167.75,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1216.19,167.75 1258.13,209.69 1216.19,209.69",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 209.69,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.25,209.69 1216.19,209.69 1174.25,251.63",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216.19,
    y: 209.69,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1216.19,209.69 1258.13,209.69 1258.13,251.63",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.125,
    y: 167.75,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.13,
    y: 167.75,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1258.13 209.69 A 41.94 41.94 0 0 1  1300.0700000000002 167.75 L 1300.0700000000002 209.69",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300.06,
    y: 167.75,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1300.06 167.75 A 41.94 41.94 0 0 1 1342 209.69 L 1300.06 209.69",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.13,
    y: 209.69,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1258.13 209.69 A 41.94 41.94 0 0 0 1300.0700000000002 251.63 L 1300.0700000000002 209.69",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300.06,
    y: 209.69,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1300.06 251.63 A 41.94 41.94 0 0 0 1342 209.69 L 1300.06 209.69",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 251.63,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,251.63 83.88,251.63 83.88,335.51",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.88,
    y: 251.63,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.88,
    y: 251.63,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.75,
    y: 251.63,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167.75 335.51 A 83.88 83.88 0 0 1  251.63 251.63 L 167.75 335.51 A 83.88 83.88 0 0 0 251.63 251.63",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.63,
    y: 251.63,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 251.63 335.51 A 83.88 83.88 0 0 1  335.51 251.63 L 335.51 335.51",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.5,
    y: 251.63,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.5,251.63 419.38,251.63 419.38,335.51",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.375,
    y: 251.625,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.38,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 419.38 293.57 A 41.94 41.94 0 0 1 461.32 251.63 L 461.32 262.115 A 31.455 31.455 0 0 0 429.865 293.57",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.31,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 461.31 251.63 A 41.94 41.94 0 0 1 503.25 293.57 L 492.765 293.57 A 31.455 31.455 0 0 0 461.31 262.115",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.38,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 419.38 293.56 A 41.94 41.94 0 0 0 461.32 335.5 L 461.32 325.015 A 31.455 31.455 0 0 1 429.865 293.56",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.31,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 461.31 335.5 A 41.94 41.94 0 0 0 503.25 293.56 L 492.765 293.56 A 31.455 31.455 0 0 1 461.31 325.015",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.25,
    y: 251.625,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.25,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "545.19,251.63 545.19,293.57 503.25,293.57",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.19,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "545.19,251.63 587.1300000000001,293.57 545.19,293.57",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.25,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "503.25,293.56 545.19,293.56 503.25,335.5",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.19,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "545.19,293.56 587.1300000000001,293.56 587.1300000000001,335.5",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.125,
    y: 251.625,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.13,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 587.13 251.63 A 41.94 41.94 0 0 1 629.0699999999999 293.57 L 587.13 293.57",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.06,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 629.06 293.57 A 41.94 41.94 0 0 1  671 251.63 L 671 293.57",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.13,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 587.13 335.5 A 41.94 41.94 0 0 0 629.0699999999999 293.56 L 587.13 293.56",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.06,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 629.06 293.56 A 41.94 41.94 0 0 0 671 335.5 L 671 293.56",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 251.63,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 251.63,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.875,
    y: 251.625,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.88,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 775.85,
    cy: 272.6,
    r: 20.97,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.81,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.81,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.88,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 775.85,
    cy: 314.53,
    r: 20.97,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.81,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.81,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 251.625,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "880.69,251.63 880.69,293.57 838.75,293.57",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.69,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "880.69,251.63 922.6300000000001,293.57 880.69,293.57",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "838.75,293.56 880.69,293.56 880.69,335.5",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.69,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "880.69,293.56 922.6300000000001,293.56 880.69,335.5",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.625,
    y: 251.625,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.63,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 922.63 251.63 A 41.94 41.94 0 0 0 964.5699999999999 293.57 L 964.5699999999999 251.63",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.56,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 964.56 293.57 A 41.94 41.94 0 0 0 1006.5 251.63 L 964.56 251.63",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.63,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 922.63 335.5 A 41.94 41.94 0 0 1  964.5699999999999 293.56 L 964.5699999999999 335.5",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.56,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 964.56 293.56 A 41.94 41.94 0 0 1 1006.5 335.5 L 964.56 335.5",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 251.625,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1006.5 293.57 A 41.94 41.94 0 0 1 1048.44 251.63 L 1048.44 262.115 A 31.455 31.455 0 0 0 1016.985 293.57",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1048.44 251.63 A 41.94 41.94 0 0 1 1090.38 293.57 L 1079.895 293.57 A 31.455 31.455 0 0 0 1048.44 262.115",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1006.5 293.56 A 41.94 41.94 0 0 0 1048.44 335.5 L 1048.44 325.015 A 31.455 31.455 0 0 1 1016.985 293.56",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1048.44 335.5 A 41.94 41.94 0 0 0 1090.38 293.56 L 1079.895 293.56 A 31.455 31.455 0 0 1 1048.44 325.015",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.375,
    y: 251.625,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.38,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1090.38 293.57 A 41.94 41.94 0 0 1 1132.3200000000002 251.63 L 1132.3200000000002 262.115 A 31.455 31.455 0 0 0 1100.865 293.57",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1132.31,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1132.31 251.63 A 41.94 41.94 0 0 1 1174.25 293.57 L 1163.7649999999999 293.57 A 31.455 31.455 0 0 0 1132.31 262.115",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.38,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1090.38 293.56 A 41.94 41.94 0 0 0 1132.3200000000002 335.5 L 1132.3200000000002 325.015 A 31.455 31.455 0 0 1 1100.865 293.56",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1132.31,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1132.31 335.5 A 41.94 41.94 0 0 0 1174.25 293.56 L 1163.7649999999999 293.56 A 31.455 31.455 0 0 1 1132.31 325.015",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 251.63,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.25,251.63 1258.13,335.51 1174.25,335.51",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.125,
    y: 251.625,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.13,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1258.13 293.57 A 41.94 41.94 0 0 1  1300.0700000000002 251.63 L 1300.0700000000002 293.57",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300.06,
    y: 251.63,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1300.06 251.63 A 41.94 41.94 0 0 1 1342 293.57 L 1300.06 293.57",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.13,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1258.13 293.56 A 41.94 41.94 0 0 0 1300.0700000000002 335.5 L 1300.0700000000002 293.56",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300.06,
    y: 293.56,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1300.06 335.5 A 41.94 41.94 0 0 0 1342 293.56 L 1300.06 293.56",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 335.5,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,335.5 83.88,419.38 0,419.38",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.88,
    y: 335.5,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.88 419.38 A 83.88 83.88 0 0 0 167.76 335.5 L 83.88 335.5",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.75,
    y: 335.5,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.75,
    y: 335.5,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.63,
    y: 335.5,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.51,335.5 335.51,419.38 251.63,419.38",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.5,
    y: 335.5,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.5,
    y: 335.5,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.44,335.5 377.44,377.44 335.5,377.44",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.44,
    y: 335.5,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.44,335.5 419.38,377.44 377.44,377.44",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.5,
    y: 377.44,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.5,377.44 377.44,377.44 377.44,419.38",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.44,
    y: 377.44,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.44,377.44 419.38,377.44 377.44,419.38",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.38,
    y: 335.5,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.38,
    y: 335.5,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.25,
    y: 335.5,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.25,
    y: 335.5,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.13,
    y: 335.5,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.13,
    y: 335.5,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 335.5,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 335.5,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 671 377.44 A 41.94 41.94 0 0 1  712.94 335.5 L 712.94 377.44",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712.94,
    y: 335.5,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 712.94 335.5 A 41.94 41.94 0 0 1 754.8800000000001 377.44 L 712.94 377.44",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 377.44,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 671 377.44 A 41.94 41.94 0 0 0 712.94 419.38 L 712.94 377.44",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712.94,
    y: 377.44,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 712.94 419.38 A 41.94 41.94 0 0 0 754.8800000000001 377.44 L 712.94 377.44",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.88,
    y: 335.5,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.88,
    y: 335.5,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 335.5,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 335.5,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 838.75 335.5 A 41.94 41.94 0 0 0 880.69 377.44 L 880.69 335.5",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.69,
    y: 335.5,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 880.69 377.44 A 41.94 41.94 0 0 0 922.6300000000001 335.5 L 880.69 335.5",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 377.44,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 838.75 419.38 A 41.94 41.94 0 0 1  880.69 377.44 L 880.69 419.38",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.69,
    y: 377.44,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 880.69 377.44 A 41.94 41.94 0 0 1 922.6300000000001 419.38 L 880.69 419.38",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.63,
    y: 335.5,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 922.63 335.5 A 83.88 83.88 0 0 1 1006.51 419.38 L 922.63 419.38",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 335.5,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 335.5,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1006.5 335.5 A 41.94 41.94 0 0 1 1048.44 377.44 L 1006.5 377.44",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 335.5,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1048.44 377.44 A 41.94 41.94 0 0 1  1090.38 335.5 L 1090.38 377.44",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 377.44,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1006.5 419.38 A 41.94 41.94 0 0 0 1048.44 377.44 L 1006.5 377.44",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 377.44,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1048.44 377.44 A 41.94 41.94 0 0 0 1090.38 419.38 L 1090.38 377.44",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.375,
    y: 335.5,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.38,
    y: 335.5,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1090.38 377.44 A 41.94 41.94 0 0 0 1132.3200000000002 335.5 L 1090.38 335.5",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1132.31,
    y: 335.5,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1132.31 335.5 A 41.94 41.94 0 0 0 1174.25 377.44 L 1174.25 335.5",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.38,
    y: 377.44,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1090.38 377.44 A 41.94 41.94 0 0 1 1132.3200000000002 419.38 L 1090.38 419.38",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1132.31,
    y: 377.44,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1132.31 419.38 A 41.94 41.94 0 0 1  1174.25 377.44 L 1174.25 419.38",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 335.5,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 335.5,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1174.25 335.5 A 41.94 41.94 0 0 0 1216.19 377.44 L 1216.19 335.5",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216.19,
    y: 335.5,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1216.19 377.44 A 41.94 41.94 0 0 0 1258.13 335.5 L 1216.19 335.5",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 377.44,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1174.25 419.38 A 41.94 41.94 0 0 1  1216.19 377.44 L 1216.19 419.38",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216.19,
    y: 377.44,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1216.19 377.44 A 41.94 41.94 0 0 1 1258.13 419.38 L 1216.19 419.38",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.125,
    y: 335.5,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.13,
    y: 335.5,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1300.0700000000002,335.5 1300.0700000000002,377.44 1258.13,377.44",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300.06,
    y: 335.5,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1300.06,335.5 1342,335.5 1300.06,377.44",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.13,
    y: 377.44,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1258.13,377.44 1300.0700000000002,377.44 1300.0700000000002,419.38",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300.06,
    y: 377.44,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1300.06,377.44 1342,419.38 1300.06,419.38",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 419.38,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 419.38,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.875,
    y: 419.375,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.88,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.82,419.38 125.82,461.32 83.88,461.32",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.81,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.81,419.38 167.75,419.38 125.81,461.32",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.88,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.88,461.31 125.82,461.31 125.82,503.25",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.81,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.81,461.31 167.75,503.25 125.81,503.25",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.75,
    y: 419.38,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.75,419.38 251.63,419.38 167.75,503.26",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.63,
    y: 419.38,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 251.63 503.26 A 83.88 83.88 0 0 1  335.51 419.38 L 251.63 503.26 A 83.88 83.88 0 0 0 335.51 419.38",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.5,
    y: 419.38,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.5,
    y: 419.38,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.375,
    y: 419.375,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.38,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 419.38 419.38 A 41.94 41.94 0 0 1 461.32 461.32 L 419.38 461.32",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.31,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 461.31 461.32 A 41.94 41.94 0 0 1  503.25 419.38 L 503.25 461.32",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.38,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 419.38 503.25 A 41.94 41.94 0 0 0 461.32 461.31 L 419.38 461.31",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.31,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 461.31 461.31 A 41.94 41.94 0 0 0 503.25 503.25 L 503.25 461.31",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.25,
    y: 419.375,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.25,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.22,
    cy: 440.35,
    r: 20.97,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.19,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.19,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.25,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.22,
    cy: 482.28,
    r: 20.97,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.19,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.19,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.125,
    y: 419.375,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.13,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.0699999999999,419.38 629.0699999999999,461.32 587.13,461.32",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.06,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.06,419.38 671,461.32 629.06,461.32",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.13,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "587.13,461.31 629.0699999999999,461.31 587.13,503.25",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.06,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.06,461.31 671,461.31 671,503.25",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 419.375,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "712.94,419.38 712.94,461.32 671,461.32",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712.94,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "712.94,419.38 754.8800000000001,419.38 712.94,461.32",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "671,461.31 712.94,461.31 712.94,503.25",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712.94,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "712.94,461.31 754.8800000000001,503.25 712.94,503.25",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.875,
    y: 419.375,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.88,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 775.85,
    cy: 440.35,
    r: 20.97,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.81,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.81,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.88,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 775.85,
    cy: 482.28,
    r: 20.97,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.81,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 796.81,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 419.375,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "880.69,419.38 880.69,461.32 838.75,461.32",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.69,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "880.69,419.38 922.6300000000001,461.32 880.69,461.32",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "838.75,461.31 880.69,461.31 880.69,503.25",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.69,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "880.69,461.31 922.6300000000001,461.31 880.69,503.25",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.625,
    y: 419.375,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.63,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 922.63 461.32 A 41.94 41.94 0 0 1 964.5699999999999 419.38 L 964.5699999999999 429.865 A 31.455 31.455 0 0 0 933.115 461.32",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.56,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 964.56 419.38 A 41.94 41.94 0 0 1 1006.5 461.32 L 996.015 461.32 A 31.455 31.455 0 0 0 964.56 429.865",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.63,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 922.63 461.31 A 41.94 41.94 0 0 0 964.5699999999999 503.25 L 964.5699999999999 492.765 A 31.455 31.455 0 0 1 933.115 461.31",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.56,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 964.56 503.25 A 41.94 41.94 0 0 0 1006.5 461.31 L 996.015 461.31 A 31.455 31.455 0 0 1 964.56 492.765",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 419.38,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1006.5 503.26 A 83.88 83.88 0 0 1  1090.38 419.38 L 1006.5 503.26 A 83.88 83.88 0 0 0 1090.38 419.38",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.375,
    y: 419.375,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.38,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1111.3500000000001,
    cy: 440.35,
    r: 20.97,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1132.31,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1132.31,
    y: 419.38,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.38,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1111.3500000000001,
    cy: 482.28,
    r: 20.97,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1132.31,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1132.31,
    y: 461.31,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 419.38,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.25,419.38 1258.13,419.38 1258.13,503.26",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.13,
    y: 419.38,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1258.13,419.38 1342.0100000000002,419.38 1342.0100000000002,503.26",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 503.25,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 503.25,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 545.19 A 41.94 41.94 0 0 1  41.94 503.25 L 41.94 545.19",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.94,
    y: 503.25,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.94 503.25 A 41.94 41.94 0 0 1 83.88 545.19 L 41.94 545.19",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 545.19,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 545.19 A 41.94 41.94 0 0 0 41.94 587.1300000000001 L 41.94 545.19",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.94,
    y: 545.19,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.94 587.1300000000001 A 41.94 41.94 0 0 0 83.88 545.19 L 41.94 545.19",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.88,
    y: 503.25,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.88,503.25 167.76,503.25 167.76,587.13",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.75,
    y: 503.25,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167.75 503.25 A 83.88 83.88 0 0 1 251.63 587.13 L 167.75 587.13",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.63,
    y: 503.25,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.63,503.25 335.51,503.25 335.51,587.13",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.5,
    y: 503.25,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.5,
    y: 503.25,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 335.5 503.25 A 41.94 41.94 0 0 1 377.44 545.19 L 335.5 545.19",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.44,
    y: 503.25,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 377.44 545.19 A 41.94 41.94 0 0 1  419.38 503.25 L 419.38 545.19",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.5,
    y: 545.19,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 335.5 587.1300000000001 A 41.94 41.94 0 0 0 377.44 545.19 L 335.5 545.19",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.44,
    y: 545.19,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 377.44 545.19 A 41.94 41.94 0 0 0 419.38 587.1300000000001 L 419.38 545.19",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.38,
    y: 503.25,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 419.38 587.13 A 83.88 83.88 0 0 0 503.26 503.25 L 419.38 503.25",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.25,
    y: 503.25,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.25,
    y: 503.25,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 503.25 545.19 A 41.94 41.94 0 0 1  545.19 503.25 L 545.19 545.19",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.19,
    y: 503.25,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 545.19 503.25 A 41.94 41.94 0 0 1 587.1300000000001 545.19 L 545.19 545.19",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.25,
    y: 545.19,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 503.25 545.19 A 41.94 41.94 0 0 0 545.19 587.1300000000001 L 545.19 545.19",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.19,
    y: 545.19,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 545.19 587.1300000000001 A 41.94 41.94 0 0 0 587.1300000000001 545.19 L 545.19 545.19",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.13,
    y: 503.25,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.13,
    y: 503.25,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 503.25,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 671 587.13 A 83.88 83.88 0 0 1  754.88 503.25 L 754.88 587.13",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.88,
    y: 503.25,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.88,
    y: 503.25,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 503.25,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 503.25,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "880.69,503.25 880.69,545.19 838.75,545.19",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.69,
    y: 503.25,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "880.69,503.25 922.6300000000001,545.19 880.69,545.19",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 545.19,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "838.75,545.19 880.69,545.19 880.69,587.1300000000001",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 880.69,
    y: 545.19,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "880.69,545.19 922.6300000000001,545.19 880.69,587.1300000000001",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.625,
    y: 503.25,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.63,
    y: 503.25,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 922.63 545.19 A 41.94 41.94 0 0 1 964.5699999999999 503.25 L 964.5699999999999 513.735 A 31.455 31.455 0 0 0 933.115 545.19",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.56,
    y: 503.25,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 964.56 503.25 A 41.94 41.94 0 0 1 1006.5 545.19 L 996.015 545.19 A 31.455 31.455 0 0 0 964.56 513.735",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.63,
    y: 545.19,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 922.63 545.19 A 41.94 41.94 0 0 0 964.5699999999999 587.1300000000001 L 964.5699999999999 576.6450000000001 A 31.455 31.455 0 0 1 933.115 545.19",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.56,
    y: 545.19,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 964.56 587.1300000000001 A 41.94 41.94 0 0 0 1006.5 545.19 L 996.015 545.19 A 31.455 31.455 0 0 1 964.56 576.6450000000001",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 503.25,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 503.25,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1027.47,
    cy: 524.22,
    r: 20.97,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 503.25,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 503.25,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 545.19,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1027.47,
    cy: 566.1600000000001,
    r: 20.97,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 545.19,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 545.19,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.38,
    y: 503.25,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1090.38 503.25 A 83.88 83.88 0 0 1  1174.2600000000002 587.13 L 1090.38 503.25 A 83.88 83.88 0 0 0 1174.2600000000002 587.13",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 503.25,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.25,503.25 1258.13,503.25 1174.25,587.13",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.13,
    y: 503.25,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1342.0100000000002,503.25 1342.0100000000002,587.13 1258.13,587.13",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 587.13,
    width: 83.88,
    height: 83.88,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,587.13 83.88,587.13 83.88,671.01",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.88,
    y: 587.13,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.88 587.13 A 83.88 83.88 0 0 1  167.76 671.01 L 83.88 587.13 A 83.88 83.88 0 0 0 167.76 671.01",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.75,
    y: 587.125,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.75,
    y: 587.13,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167.75 629.0699999999999 A 41.94 41.94 0 0 0 209.69 587.13 L 167.75 587.13",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.69,
    y: 587.13,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 209.69 587.13 A 41.94 41.94 0 0 0 251.63 629.0699999999999 L 251.63 587.13",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.75,
    y: 629.06,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167.75 629.06 A 41.94 41.94 0 0 1 209.69 671 L 167.75 671",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.69,
    y: 629.06,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 209.69 671 A 41.94 41.94 0 0 1  251.63 629.06 L 251.63 671",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.63,
    y: 587.13,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.63,587.13 335.51,587.13 251.63,671.01",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.5,
    y: 587.125,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.5,
    y: 587.13,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 335.5 629.0699999999999 A 41.94 41.94 0 0 0 377.44 587.13 L 335.5 587.13",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.44,
    y: 587.13,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 377.44 587.13 A 41.94 41.94 0 0 0 419.38 629.0699999999999 L 419.38 587.13",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.5,
    y: 629.06,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 335.5 629.06 A 41.94 41.94 0 0 1 377.44 671 L 335.5 671",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.44,
    y: 629.06,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 377.44 671 A 41.94 41.94 0 0 1  419.38 629.06 L 419.38 671",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.38,
    y: 587.13,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.38,587.13 503.26,587.13 503.26,671.01",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.25,
    y: 587.13,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.25,
    y: 587.13,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.13,
    y: 587.13,
    width: 83.88,
    height: 83.88,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 587.13 671.01 A 83.88 83.88 0 0 1  671.01 587.13 L 587.13 671.01 A 83.88 83.88 0 0 0 671.01 587.13",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 587.125,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 587.13,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "712.94,587.13 712.94,629.0699999999999 671,629.0699999999999",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712.94,
    y: 587.13,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "712.94,587.13 754.8800000000001,587.13 712.94,629.0699999999999",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671,
    y: 629.06,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "671,629.06 712.94,629.06 712.94,671",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712.94,
    y: 629.06,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "712.94,629.06 754.8800000000001,671 712.94,671",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754.88,
    y: 587.13,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 754.88 587.13 A 83.88 83.88 0 0 1 838.76 671.01 L 754.88 671.01",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.75,
    y: 587.13,
    width: 83.88,
    height: 83.88,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "838.75,587.13 922.63,587.13 838.75,671.01",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.625,
    y: 587.125,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.63,
    y: 587.13,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 922.63 629.0699999999999 A 41.94 41.94 0 0 1  964.5699999999999 587.13 L 964.5699999999999 629.0699999999999",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.56,
    y: 587.13,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 964.56 587.13 A 41.94 41.94 0 0 1 1006.5 629.0699999999999 L 964.56 629.0699999999999",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 922.63,
    y: 629.06,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 922.63 629.06 A 41.94 41.94 0 0 0 964.5699999999999 671 L 964.5699999999999 629.06",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.56,
    y: 629.06,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 964.56 671 A 41.94 41.94 0 0 0 1006.5 629.06 L 964.56 629.06",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 587.125,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 587.13,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1048.44,587.13 1048.44,629.0699999999999 1006.5,629.0699999999999",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 587.13,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1048.44,587.13 1090.38,629.0699999999999 1048.44,629.0699999999999",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.5,
    y: 629.06,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1006.5,629.06 1048.44,629.06 1006.5,671",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.44,
    y: 629.06,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1048.44,629.06 1090.38,629.06 1090.38,671",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.375,
    y: 587.125,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.38,
    y: 587.13,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1132.3200000000002,587.13 1132.3200000000002,629.0699999999999 1090.38,629.0699999999999",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1132.31,
    y: 587.13,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1132.31,587.13 1174.25,629.0699999999999 1132.31,629.0699999999999",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.38,
    y: 629.06,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1090.38,629.06 1132.3200000000002,629.06 1132.3200000000002,671",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1132.31,
    y: 629.06,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1132.31,629.06 1174.25,629.06 1132.31,671",
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 587.125,
    width: 83.875,
    height: 83.875,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 587.13,
    width: 41.94,
    height: 41.94,
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1216.19,587.13 1216.19,629.0699999999999 1174.25,629.0699999999999",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216.19,
    y: 587.13,
    width: 41.94,
    height: 41.94,
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1216.19,587.13 1258.13,587.13 1216.19,629.0699999999999",
    fill: "#46848C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1174.25,
    y: 629.06,
    width: 41.94,
    height: 41.94,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1174.25,629.06 1216.19,629.06 1216.19,671",
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1216.19,
    y: 629.06,
    width: 41.94,
    height: 41.94,
    fill: "#2A5166"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1216.19,629.06 1258.13,671 1216.19,671",
    fill: "#75DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1258.13,
    y: 587.13,
    width: 83.88,
    height: 83.88,
    fill: "#172A3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1342.0100000000002,587.13 1342.0100000000002,671.01 1258.13,671.01",
    fill: "#172A3A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.30d1ea43cdba9d54a8ed1c0c7aaf187a.svg";
export { ForwardRef as ReactComponent };